import React from 'react';
import styled from 'styled-components';

import Icon from '@monolith/components/0-atoms/Icon';
import type { StaffImportToast as StaffImportToastState } from '../types/staffImport';

export interface StaffImportToastProps {
    toast: StaffImportToastState;
    onDismiss: () => void;
}

const NAV_TOPBAR_HEIGHT = 'var(--opus-navigation-topbar-height, 70px)';
const TOAST_OFFSET = '24px';

const ToastContainer = styled.div<{
    $variant: StaffImportToastState['variant'];
}>`
    position: fixed;
    top: calc(${NAV_TOPBAR_HEIGHT} + ${TOAST_OFFSET});
    right: 24px;
    z-index: 1051;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    min-width: 280px;
    max-width: 420px;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
    background: ${(props) =>
        props.$variant === 'error' ? '#ff4141' : '#2e7d32'};
    color: #ffffff;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
`;

const Title = styled.p`
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
`;

const Message = styled.p`
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 17px;
`;

const DismissButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    color: inherit;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
        opacity: 0.85;
    }
`;

export const StaffImportToast: React.FC<StaffImportToastProps> = ({
    toast,
    onDismiss,
}) => {
    return (
        <ToastContainer
            $variant={toast.variant}
            role="alert"
            aria-live="assertive"
        >
            <Content>
                <Title>{toast.title}</Title>
                {toast.message ? <Message>{toast.message}</Message> : null}
            </Content>
            <DismissButton
                type="button"
                aria-label="Dismiss notification"
                onClick={onDismiss}
            >
                <Icon fasIcon="xmark" />
            </DismissButton>
        </ToastContainer>
    );
};

export default StaffImportToast;
